import React, { useState } from "react";

const options = ["ERPIWXF2826CHN", "spflerp2O25", "erpsppipe"];

export default function DatabaseKeyPage() {
  const [key, setKey] = useState(sessionStorage.getItem("databaseKey") || "");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!key.trim()) {
      setError("Please enter a valid database key.");
      return;
    }
    sessionStorage.setItem("databaseKey", key.trim());
    // Navigate to login page
    window.location.href = '/login';
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img
          src="https://cdn-icons-png.flaticon.com/512/4221/4221392.png"
          alt="Database Key"
          style={styles.image}
        />
        <h1 style={styles.title}>Inspection Portal</h1>
        <p style={styles.subtitle}>Enter your Database Key to continue</p>

        <form onSubmit={handleSubmit}>
          <select
            value={key}
            onChange={(e) => setKey(e.target.value)}
            style={styles.select}
          >
            <option value="">-- Select Key --</option>
            {options.map((keyOption) => (
              <option key={keyOption} value={keyOption}>
                {keyOption}
              </option>
            ))}
          </select>
          {error && <p style={styles.error}>{error}</p>}

          <button type="submit" style={styles.button}>
            Continue
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #2563eb, #7c3aed)",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    padding: "20px",
  },
  card: {
    background: "#fff",
    borderRadius: "16px",
    boxShadow: "0 8px 25px rgba(0, 0, 0, 0.2)",
    padding: "40px 30px",
    width: "100%",
    maxWidth: "400px",
    textAlign: "center",
  },
  image: {
    width: "80px",
    marginBottom: "20px",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#1e293b",
    marginBottom: "8px",
  },
  subtitle: {
    fontSize: "14px",
    color: "#64748b",
    marginBottom: "24px",
  },
  select: {
    width: "100%",
    padding: "12px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    outline: "none",
    marginBottom: "15px",
    transition: "all 0.2s ease",
    backgroundColor: "#fff",
  },
  button: {
    width: "100%",
    padding: "12px",
    fontSize: "16px",
    border: "none",
    borderRadius: "8px",
    backgroundColor: "#2563eb",
    color: "#fff",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
  buttonHover: {
    backgroundColor: "#1d4ed8",
  },
  error: {
    color: "red",
    fontSize: "0.9rem",
    marginBottom: "10px",
  },
};
